import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var AddColumnIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6921 9.13694C5.17618 9.13694 4.75598 9.55768 4.75598 10.0743V43.0542C4.75598 43.5707 5.17618 43.9915 5.6921 43.9915H38.6303C39.1462 43.9915 39.5664 43.5707 39.5664 43.0542V23.0895C39.5664 22.5348 40.0154 22.0852 40.5694 22.0852C41.1233 22.0852 41.5724 22.5348 41.5724 23.0895V43.0542C41.5724 44.68 40.2541 46 38.6303 46H5.6921C4.06831 46 2.75 44.68 2.75 43.0542V10.0743C2.75 8.44841 4.06831 7.12842 5.6921 7.12842H24.5483C25.1022 7.12842 25.5513 7.57805 25.5513 8.13268C25.5513 8.68732 25.1022 9.13694 24.5483 9.13694H5.6921Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1679 7.12842C22.7218 7.12842 23.1709 7.57805 23.1709 8.13268V43.9915H30.3656V23.4644C30.3656 22.9098 30.8147 22.4601 31.3686 22.4601C31.9226 22.4601 32.3716 22.9098 32.3716 23.4644V44.9957C32.3716 45.5504 31.9226 46 31.3686 46H22.1679C21.6139 46 21.1649 45.5504 21.1649 44.9957V8.13268C21.1649 7.57805 21.6139 7.12842 22.1679 7.12842Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M22.1669 44.9948V8.13175H12.9662V44.9948H22.1669Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1679 7.12842C22.7218 7.12842 23.1709 7.57805 23.1709 8.13268L23.1699 44.9948C23.1699 45.5494 22.7218 46 22.1679 46L12.9662 45.9991C12.4122 45.9991 11.9632 45.5494 11.9632 44.9948V8.13175C11.9632 7.57711 12.4122 7.12749 12.9662 7.12749L22.1679 7.12842ZM21.1639 9.13601H13.9692V43.9905H21.1639V9.13601Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6778 4.00852C33.0514 4.00852 30.1115 6.95205 30.1115 10.5831C30.1115 14.2141 33.0514 17.1576 36.6778 17.1576C40.3042 17.1576 43.244 14.2141 43.244 10.5831C43.244 6.95205 40.3042 4.00852 36.6778 4.00852ZM28.1056 10.5831C28.1056 5.84278 31.9435 2 36.6778 2C41.4121 2 45.25 5.84278 45.25 10.5831C45.25 15.3234 41.4121 19.1662 36.6778 19.1662C31.9435 19.1662 28.1056 15.3234 28.1056 10.5831Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.385 10.5831C32.385 10.0284 32.834 9.57882 33.388 9.57882H39.9676C40.5215 9.57882 40.9706 10.0284 40.9706 10.5831C40.9706 11.1377 40.5215 11.5873 39.9676 11.5873H33.388C32.834 11.5873 32.385 11.1377 32.385 10.5831Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6778 6.29824C37.2317 6.29824 37.6808 6.74786 37.6808 7.3025V13.8771C37.6808 14.4317 37.2317 14.8813 36.6778 14.8813C36.1238 14.8813 35.6748 14.4317 35.6748 13.8771V7.3025C35.6748 6.74786 36.1238 6.29824 36.6778 6.29824Z"
  }));
});
AddColumnIcon.displayName = 'AddColumnIcon';
AddColumnIcon.defaultProps = {
  'aria-label': 'AddColumn'
};
export default AddColumnIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/AddColumnIcon/index.js
// module id = 1782
// module chunks = 12